import styled from "styled-components";

const Table = styled.table`
  width: 100%;
  display: ${p => (p.visible ? "grid" : "none")};
  tr {
    display: grid;
  }

  @media (min-width: 768px) {
    border: 1px solid var(--color-light-gray);
    tr {
      grid-template-columns: ${p => p.width}; //120px 80px 100px 1fr 150px 90px;

      th,
      td {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      th {
        background-color: var(--color-light-gray);
        font-weight: bold;
      }

      td {
        //border: 1px solid var(--color-gray);
      }
    }
  }

  @media (max-width: 767px) {
    thead {
      display: none;
    }
    tr {
      border: 1px solid var(--color-light-gray);
      &:not(:first-child) {
        margin-top: 10px;
      }
      grid-template-columns: 1fr 1fr;
    }
    td {
      padding: 7px 10px;
      display: flex;
      align-items: center;
    }
    td::before {
      color: var(--color-gray);
      content: attr(data-th);
      margin-right: 5px;
    }
  }

  @media (max-width: 413px) {
    tr {
      grid-template-columns: 1fr;
    }
  }
`;

export default Table;
